import { T } from "@repo/transifex";

type OrderMinimumHintProps = {
  orderMin: number | null;
};

export const OrderMinimumHint = ({ orderMin }: OrderMinimumHintProps) => {
  if (orderMin === null || orderMin <= 1) return null;

  return (
    <p className="text-2xl text-kiosk-text-secondary">
      <T _str="Minimum {minimum} per order" minimum={orderMin} />
    </p>
  );
};
